module.exports = __webpack_public_path__ + "img/switchOff.f527111c.svg";